import { Box, Tooltip, InfoIcon } from 'edenred-ui';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BenefitHeader } from './BenefitHeader';
import { IAvailableBenefits } from '@epi-models/containers/ManageBenefits';
import { useTheme } from 'styled-components';
import { DailyLimitField } from '@epi-containers/ManageBenefitGroups/components/DailyLimitField';

type OwnProps = {
  benefit: IAvailableBenefits;
  maxAmounts: number[];
  index: number;
};

const BenefitSettingsItem = ({ benefit, maxAmounts, index }: OwnProps) => {
  const { primaryFrontColor } = useTheme();
  const { t } = useTranslation();
  return (
    <Box
      key={benefit.id}
      border="1px solid #E0E0E0"
      padding="24px"
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <BenefitHeader benefitName={benefit.type} />
      <Box display="flex" alignItems="center" gap={1}>
        <DailyLimitField
          label={t(
            `components.manage_benefit_${benefit.type}.detail_limit_label`
          )}
          readOnly={false}
          benefitType={benefit.type.toLowerCase()}
          options={[]}
          name={`groups.${index}.maxAmountPerPeriod`}
          fundsLoadingTypeName={`groups.${index}.fundsLoadingType`}
          maxAmounts={maxAmounts}
        />
        <Tooltip
          arrow
          placement="top"
          id={`lounari-limit-section-limit-tooltip-${benefit.type}`}
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: '500px'
              }
            },
            popper: {
              sx: { zIndex: 7000 }
            }
          }}
          title={
            <Trans
              i18nKey={`components.manage_benefit_${benefit.type?.toLowerCase()}.detail_daily_limit_statement`}
            />
          }
        >
          <Box
            pl={1}
            pt="4x"
            id={`lounari-limit-section-limit-tooltip-icon-${benefit.type}`}
          >
            <InfoIcon color={primaryFrontColor} />
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};
export default BenefitSettingsItem;
